module.exports = __webpack_public_path__ + "static/media/logo-blue.16eb97c8.png";